import { useState } from 'react';

const useFormState = () => {
  const [showForm, setShowForm] = useState<boolean>(true);

  const handleOpenForm = () => {
    setShowForm(true);
  };
  const handleCloseForm = () => {
    setShowForm(false);
  };

  return {
    showForm,
    handleCloseForm,
    handleOpenForm
  };
};

export default useFormState;
